import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';
import Routes from './routes/Routes';

/*global GlideFormHandler*/
let FormHandler;

window.addEventListener('load', function () {
  if (typeof GlideFormHandler === 'undefined') {
    FormHandler = {
      appCloseWebView: function () {
        alert("That's all folks");
      },
    };
  } else {
    FormHandler = GlideFormHandler;
    console.log('Defined');
  }

  window.formHandler = FormHandler;

  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <Routes />
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
